import axios from 'axios';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

const state = {
	bookingInfo: {},
	bookingClinic: {},
	bookingCustomer: {},
	bookingPermalink: {
		min_time_routine: '00:00',
		max_time_routine: '24:00',
		slot_duration: '00:30:00'
	},
	bookingEditStep: 'EditBookingCalendar',
	eventSelected: {},
	bookingTherapist: {
		image: {
			url: '/images/user-chat.png'
		}
	},
	bookingLoading: true
}

const mutations = {
	SET_BOOKING_INFO(state, payload) {
		state.bookingInfo = payload;
	},
	SET_BOOKING_CUSTOMER(state, payload) {
		state.bookingCustomer = payload;
	},
	SET_BOOKING_CLINIC(state, payload) {
		state.bookingClinic = payload;
	},
	SET_BOOKING_PERMALINK(state, payload) {
		state.bookingPermalink = payload;
	},
	SET_BOOKING_EVENT(state, payload) {
		state.eventSelected = payload;
	},
	SET_CURRENT_STEP(state, payload) {
		state.bookingEditStep = payload;
	},
	SET_BOOKING_THERAPIST(state, payload) {
		state.bookingTherapist = payload;
	},
	SET_BOOKING_TIME(state, payload) {
		const daysOfWeek = ['日', '月', '火', '水', '木', '金', '土'];
		const start = new Date(payload.startStr);
		const totalMinutes = state.bookingInfo.total_minutes;
		const end = new Date(start.getTime() + totalMinutes * 60000);
		const year = start.getFullYear();
		const month = start.getMonth() + 1;
		const date = start.getDate();
		const day = daysOfWeek[start.getDay()];
		const startTime = start.toTimeString().slice(0, 5);
		const endTime = end.toTimeString().slice(0, 5);
		state.bookingInfo.start = start;
		state.bookingInfo.end = end;
		state.bookingInfo.booking_time = `${year}年${month}月${date}日 (${day}) ${startTime} ~ ${endTime}`;
	},
	UPDATE_BOOKING_TIME(state) {
		$.ajax({
			url: `/api/v1/front/bookings/${state.bookingInfo.id}`,
			headers: {
				'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
			},
			type: 'PUT',
			data: {
				time_start: state.eventSelected.startStr
			},
			success: function(res) {
				window.location.href = `/bookings/${state.bookingInfo.id}/edit_complete`;
			},
			error: function (res) {
				let responseJson = jQuery.parseJSON(res.responseText);
				toastr.error(responseJson.error);
			}
		});
	},
	SET_BOOKING_LOADING(state, payload) {
		state.bookingLoading = payload;
	},
}

const actions = {
	async getBooking({ commit }, bookingId) {
		try {
			commit('SET_BOOKING_LOADING', true);
			const res = await axios.get(`/api/v1/front/bookings/${bookingId}`);
			if (res.data) {
				commit('SET_BOOKING_INFO', res.data?.info);
				commit('SET_BOOKING_CUSTOMER', res.data?.customer);
				commit('SET_BOOKING_CLINIC', res.data?.clinic);
				commit('SET_BOOKING_PERMALINK', res.data?.permalink);
				commit('SET_BOOKING_THERAPIST', res.data?.therapist);
			} else {
				toastr.error(response.data.error);
			}
		
		} catch (error) {
			toastr.error('エラーが発生しました。ブラウザをリロードして再度お試しください。');
		}
	},
	setBookingEvent({ commit }, event) {
		commit('SET_BOOKING_EVENT', event);
		commit('SET_BOOKING_TIME', event);
		commit('SET_CURRENT_STEP', 'BookingEditConfirm');
	},
	setBookingEditStep({ commit }, step) {
		commit('SET_CURRENT_STEP', step);
	},
	updateBooking({ commit }) {
		commit('UPDATE_BOOKING_TIME');
	},
	setBookingLoading({ commit }, isLoading) {
		commit('SET_BOOKING_LOADING', isLoading);
	}
}

const getters = {
	bookingInfo: state => state.bookingInfo,
	bookingCustomer: state => state.bookingCustomer,
	bookingClinic: state => state.bookingClinic,
	bookingPermalink: state => state.bookingPermalink,
	bookingEditStep: state => state.bookingEditStep,
	eventSelected: state => state.eventSelected,
	bookingTherapist: state => state.bookingTherapist,
	bookingLoading: state => state.bookingLoading
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}